import type { Profile } from '../../profile.types';
import type { OtherInformationFormState } from './useEditOtherInformationPanel.types';

function buildInitialOtherInformationFormState(profile?: Profile): OtherInformationFormState {
  return {
    nickName: profile?.nickName ?? '',
  };
}

export { buildInitialOtherInformationFormState };
